module.exports = __webpack_public_path__ + "static/img/banner bgi.ce0c9a2d.jpg";